<template>
    <div id="settings-page" class="gradbg">
        <div class="header-panel">
            <h1>First Home Saver Settings</h1>
        </div>
        <div class="list-panel">
            <ul>
                <li><router-link to="/main/account-select">Manage Bank Accounts</router-link></li>
                <li><router-link to="/main/transfers">Set Up Automatic Transfers</router-link></li>
                <li><router-link to="">Open a New Savings Account</router-link></li>
                <li><router-link to="/main/transfer-history">View Transfer History</router-link></li>
                <li><router-link to="">Notifications</router-link></li>
                <li><router-link to="">Close Account</router-link></li>
                <li><router-link to="">Disclosures</router-link></li>
            </ul>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
    name: 'settings',
    data() {
        return {
        }
    },
    computed: {
        ...mapState(['bankInfo']),
    },
    methods: {
    },
}
</script>
<style lang="scss">
#settings-page {
    flex: 1 1 100%;

    display: flex;
    flex-flow: column nowrap;
    height: 100%;

    .list-panel {
        flex: 1 1 100%;
        background: white;

        ul {
            li {
                border-bottom: solid 1px #DFE2E5;
                text-align: left;

                a {
                    padding: 16px 20px;
                    display: block;
                    font-size: 13px;
                    font-weight: bold;
                    color: black;
                    text-decoration: none;
                }
            }
        }
    }
}
</style>
